<template>
    <div>
        <table-grid :items='awsAccountPermissionStatistics' :columns='columns'></table-grid>
    </div>
</template>
<script>
    import TableGrid from '../permission/TableGrid'
    let tablePermissionsVue = {};
    export default {
        components: {TableGrid},
        name: 'TablePermissions',
        data() {
            return {
                companyId: 0,
                accountIds: [],
                columns: [
                {
                    title: this.$t('permission_configuration_management.user.companyName'),
                    key: 'companyName'
                },
                {
                    title: this.$t('permission_configuration_management.group.accountName'),
                    key: 'accountName'
                },
                {
                    title: this.$t('permission_configuration_management.group.accountId'),
                    key: 'awsAccount'
                },
                {
                    title: this.$t('permission_configuration_management.permission.templateName'),
                    key: 'templateName'
                },
                {
                    title: this.$t('permission_configuration_management.permission.permissions'),
                    key: 'permissions'
                },
                {
                    title: this.$t('permission_configuration_management.permission.authorized'),
                    key: 'exist'
                }],
                awsAccountPermissionStatistics: []
            }
        },
        beforeCreate: function () {
            tablePermissionsVue = this
        },
        mounted: function () {
            tablePermissionsVue.getAWSAccountPermissionStatistics();
        },
        methods: {
            showAll: function () {
                tablePermissionsVue.getAWSAccountPermissionStatistics();
            },
            // 获取策略一览数据
            getAWSAccountPermissionStatistics: function () {
                eventBus.$on('companyId', function (val) {
                    tablePermissionsVue.companyId = val;
                })
                eventBus.$on('accountIds', function (val) {
                    tablePermissionsVue.accountIds = val;
                })
                eventBus.$on('exist', function (val) {
                    tablePermissionsVue.exist = val;
                })
                //获取AWS账户策略一览
                this.$api.account.getAWSAccountPermissionStatistics({
                    "companyId": tablePermissionsVue.companyId,
                    "accountIds": tablePermissionsVue.accountIds,
                    "exist": tablePermissionsVue.exist
                })
                .then(res => {
                    this.awsAccountPermissionStatistics = res.data;
                    for(var i=0;i<this.awsAccountPermissionStatistics.length;i++){
                        for(var j=0;j<this.awsAccountPermissionStatistics[i].children.length;j++){
                            if(this.awsAccountPermissionStatistics[i].children[j].exist){
                                this.awsAccountPermissionStatistics[i].children[j].exist=this.$t('permission_configuration_management.permission.owned');
                            }else{
                                this.awsAccountPermissionStatistics[i].children[j].exist=this.$t('permission_configuration_management.permission.notOwned');
                            }
                        }
                    }
                });
            },
            beforeDestroy: function () {
                eventBus.$off('companyId');
                eventBus.$off('accountIds');
                eventBus.$off('exist');
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/permission/TablePermissions.vue